import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';
import { FormatBankValuesService, RevenueSummaryDataFormatted } from '../format-bank-values.service';

@Component({
  selector: 'app-bank-values',
  templateUrl: './bank-values.component.html',
  styleUrls: ['./bank-values.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BankValuesComponent implements OnInit, OnChanges {

  @Input() bankValues: BorrowerValue[];

  dataSource: MatTableDataSource<RevenueSummaryDataFormatted> = new MatTableDataSource();
  currencySymbol: string | null;
  currencyCode: string | null;

  displayedColumns: string[] = ['timeDuration', 'totalSalesAmtAverage', 'salesDepositsCountAvg',
    'creditsAmountAvg', 'creditsCountAvg', 'daysNegativeAvg', 'daysNegativeTotal', 'batchDays', 'nsfTransactionsAvg',
    'nsfTransactionsTotal', 'balanceAvg', 'endingStatementBalanceMin', 'endingStatementBalanceAvg'];

  constructor(private formatBankValuesService: FormatBankValuesService,
    private localeSettingService: LocaleSettingService,
  ) { }

  ngOnInit(): void {
    this.currencySymbol = this.localeSettingService.getLocaleCurrencySymbol();
    this.currencyCode = this.localeSettingService.getCurrencyCode();
  }

  ngOnChanges(): void {
    this.dataSource.data = this.formatBankValuesService.getBankValuesFormatted(this.bankValues);
  }

}
